import "./terms-and-conditions.styles.css";

export const TermsConditions = () => {
  return (
    <div className="rootTermsConditions">
      <div className="bodyTermsConditions">
        <h1 className="titlex02">
          KYC PLATFORM TERMS & CONDITIONS AND PRIVACY POLICY
        </h1>
        <h2 className="subTitlex02"> 27 th of February 2025</h2>
        <div className="boxTextx02">
          <h4>1. Important information </h4>
          <p>
            Please read these terms and conditions carefully before using the
            Know Your Customer (hereinafter KYC) platform. Our site(s) and our
            App(s), such as but not limited to https://icreditkyc.com
            (hereinafter Icredit) are operated by Icredit (PTY) Ltd, a company
            registered in Eswatini. These Terms and Conditions and the Privacy
            Policies combined constitute a legal Agreement (The “Agreement”)
            between Icredit (PTY) Ltd and the platform user (you or your), and
            you can find them in our App or website at any time.
          </p>
          <h4>2. Services</h4>
          <p>
            We are a <strong>KYC (Know Your Customer) provider</strong>
             specializing in the verification of 
            <strong>Eswatini National Identity Cards</strong>. Our advanced
            verification solutions are designed to ensure seamless and secure
            identity validation, helping businesses comply with regulatory
            requirements while enhancing customer onboarding processes. With a
            strong focus on accuracy and efficiency, we leverage cutting-edge
            technology to authenticate Eswatini National ID cards, providing
            reliable results in real-time. Whether you're in banking, fintech,
            or any other industry requiring robust identity verification, our
            services are tailored to meet your needs and streamline your
            operations. Trust us to deliver secure, compliant, and user-friendly
            solutions that prioritize both security and convenience. By using
            our KYC platform, you confirm that all information provided
            is truthful, accurate, and complete. This ensures a seamless
            verification process and helps maintain the integrity of our
            services. We rely on the accuracy of the details you submit to
            deliver reliable and secure identity verification. Any discrepancies
            or false information may result in delays or the inability to
            complete the verification process. Your commitment to providing
            truthful information not only supports compliance with regulatory
            standards but also enhances trust and security for all parties
            involved.
          </p>
          <h4>3. When we can change these terms </h4>
          <p>
            We may change these or any such other additional T&Cs (terms or
            Terms and Conditions) at any time except for any additional charges
            or fees charged to you if any of those changes becoming more
            expensive to you than we will notify you 2 months before or 60
            calendar days before, whichever comes earlier. Any reduction in
            charges or fees that have a beneficial effect to you are at our sole
            discretion and are aimed to be implemented at any time and at our
            sole discretion, without any prior notice and we reserve the right
            to apply discounts or even waive certain fees or charges on our
            published charges or fees for certain individual accounts that we
            select, if any, at any time at our sole discretion. We also may
            change our T&Cs if any part of them is inconsistent with any
            regulatory requirement and you herewith consent that we can replace
            any non-compliant part or whole with new legally compliant parts or
            whole with the same original intend or meaning. Any changes in our
            T&Cs, and/or any additional T&Cs, or our Privacy Policies that do
            not affect any charges or fees having a negative effect to you, we
            reserve the right to change all those at any time, at our sole
            discretion, and without any prior notice. So please read all our
            T&Cs and Privacy Policies regularly by checking the date of the
            latest version available through our website(s) and/or our App(s).
            Any new and/or additional T&Cs of any kind, such as but not limited
            additional T&Cs for referral programs or any such other programs or
            any other additional T&Cs or new services can be added by us at any
            time, at our sole discretion without any prior notice.
          </p>
          <h4>4. Commence and Termination of this Agreement</h4>
          <p>
            This Agreement will commence when we notify you that we have
            accepted your application by accepting your KYC and creating a
            account for you or accepting an order for a Card for you and will
            continue until terminated by you or by us at our sole discretion. We
            can also terminate this Agreement with immediate effect if you have
            breached any clause of any of our T&Cs or Privacy Policies or we
            have a reason to believe or suspect that you have used or intend to
            use the platform a negligent, fraudulent or non-ethical manner or in
            any other unlawful purposes, or if we cancel your access to the
            platform. In the event that any additional fees are found to have
            been incurred on your account following termination by us, then
            subject to this Agreement, you must refund to us any sum which
            relates to a withdrawal on the account or fees and/or charges
            validly applied whether before or after termination. We will send a
            refund request to you and will require you to refund us immediately.
            Should you not repay this amount immediately after receiving the
            request for refund from us, we reserve the right to take all steps
            necessary, including legal action, to recover any monies outstanding
            from you to us.
          </p>
          {/*  */}
          <h4>5. How to make a complaint </h4>
          <p>
            If you are unhappy with any element of the services provides by us,
            then a complaint message can be sent by you to Customer Service via
            the app or via email to [*]. One we have received your compliant we
            aim to investigate the complaint and give you a response within a
            couple of days but this can take up to 15 business days depending on
            our work load.
          </p>
          <h4>6. Contacting customer service </h4>
          <p>
            If you want to contact us with regards to any matter related to our
            services you can contact us via our App or via email to [*] Lost,
            damaged or stolen cards can be reported preferably via the App as
            that is the fastest way that you can Freeze/Block your Card,
            alternatively by email to [*] which is the slowest way or if you
            lost your phone and have no access to the App than you can contact
            us to report this by calling [*].
          </p>
          <h4>7. Our Intellectual property </h4>
          <p>
            We own or licence all intellectual property rights in our brand and
            name, our software, our App(s) and our Cloud infrastructure and all
            related materials. No right (including any intellectual property
            rights) in the aforementioned will vest in you at any time and you
            must not use our intellectual property as your own. We provide you
            herewith the right of use of our App(s) and services strictly and
            only in so long you remain a customer of us and have an active
            account with us.
          </p>
          <h4>8. Miscellaneous </h4>
          <ul className="ul_x02">
            <li>
              This Agreement is personal and only binds you and Icredit. You
              cannot transfer any right or obligation under it to anyone else.
            </li>
            <li>
              Each term or condition of this Agreement operates independently
              and if any such term or condition is deemed unlawful or
              unenforceable at any time, then you consent herewith that any such
              unlawful or unenforceable part(s) will not affect any other term
              of this Agreement and you consent herewith that any such unlawful
              or unenforceable part(s) will be replaced by new wording with the
              same meaning or original intend which is deemed lawful or
              enforceable.
            </li>
            <li>
              This Agreement is governed by Eswatini law and Eswatini courts
              will have exclusive jurisdiction to decide about any dispute in
              connection with this Agreement.
            </li>
            <li>
              No third party who is not a party in this Agreement has any right
              to enforce any of the clauses in this Agreement.
            </li>
            <li>
              If these terms and conditions or any such other additional terms
              and conditions or our privacy policies are translated into any
              another language, the English version will prevail.
            </li>
            <li>
              The personal information we have collected from you will be shared
              with fraud prevention agencies who will use it to prevent fraud
              and money-laundering and to verify your identity. If fraud is
              detected, you could be refused certain services, finance. 
              Further details of how your information will be used
              by us and these fraud prevention agencies, and your data
              protection rights, can be found in our privacy policy. Whenever
              fraud prevention agencies transfer your personal data outside of
              the country where this service is provided or the country where your
              personal data is stored, they impose contractual obligations on
              the recipients of that data to protect your personal data to the
              standard required in the country where this service is provided.
              They may also require the recipient to subscribe to ‘international frameworks’
              intended to enable secure data sharing.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
